import { Input } from "@/components/ui/input";
import type { SearchMode, ResultFilter } from "@/lib/types";
import { config } from "@/lib/config";

interface SearchBoxProps {
  value: string;
  onChange: (value: string) => void;
  searchMode: SearchMode | null;
  disabled?: boolean;
  filter: ResultFilter;
  onFilterChange: (filter: ResultFilter) => void;
  jyutpingCount: number;
  englishCount: number;
}

export function SearchBox({
  value,
  onChange,
  searchMode,
  disabled = false,
  filter,
  onFilterChange,
  jyutpingCount,
  englishCount,
}: SearchBoxProps) {
  const showFilters = searchMode === "text" && value.trim() && (jyutpingCount > 0 || englishCount > 0);
  const totalCount = jyutpingCount + englishCount;

  return (
    <div className="w-full max-w-2xl mx-auto">
      <div className="relative">
        <Input
          type="text"
          placeholder={config.searchPlaceholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
          className="text-lg py-6 pr-12"
          autoFocus
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange("")}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Clear search"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        )}
      </div>

      {showFilters && (
        <div className="mt-3 flex items-center gap-2 flex-wrap">
          <span className="text-sm text-muted-foreground">Filter:</span>
          <button
            onClick={() => onFilterChange("all")}
            className={`px-3 py-1 text-sm rounded-full transition-colors ${
              filter === "all"
                ? "bg-primary text-primary-foreground"
                : "bg-muted hover:bg-muted/80"
            }`}
          >
            All ({totalCount})
          </button>
          {jyutpingCount > 0 && (
            <button
              onClick={() => onFilterChange("jyutping")}
              className={`px-3 py-1 text-sm rounded-full transition-colors ${
                filter === "jyutping"
                  ? "bg-primary text-primary-foreground"
                  : "bg-muted hover:bg-muted/80"
              }`}
            >
              {config.pronunciationLabel} ({jyutpingCount})
            </button>
          )}
          {englishCount > 0 && (
            <button
              onClick={() => onFilterChange("english")}
              className={`px-3 py-1 text-sm rounded-full transition-colors ${
                filter === "english"
                  ? "bg-primary text-primary-foreground"
                  : "bg-muted hover:bg-muted/80"
              }`}
            >
              English ({englishCount})
            </button>
          )}
        </div>
      )}
    </div>
  );
}
